import { SortDirection } from '../../../../utils/constants';
import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';

export const filterFields = {
  DocumentName: 'DocumentName',
  CreatedOnFrom: 'CreatedOnFrom',
  CreatedOnTo: 'CreatedOnTo',
};

const initialFilterState = {
  DocumentName: '',
  CreatedOnFrom: '',
  CreatedOnTo: '',
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'DocumentName',
  sortDirection: SortDirection.Asc,
};

export const sliceName = 'sharedFilesSearch';

const sharedFilesSearchSlice = createSearchPageSlice({
  sliceName,
  filterFields,
  initialFilterState,
  initialPageState
});

export const tableInfoFields = {
  page: 'page',
  pageSize: 'pageSize',
  sortColumn: 'sortColumn',
  sortDirection: 'sortDirection',
};

export const sharedFilesSearchActions = sharedFilesSearchSlice.actions;
export default sharedFilesSearchSlice.reducer;
